import Model from '@/models/Model'
import merchantCategoryCodes from 'assets/data/yapily/merchant-category-codes'

export const OPEN_BANKING_PPC_USER_GROUPS = [
  'WHOLESALE_FI_FI',
  'COMMERCIAL',
  'CONSUMER_GOODS_SERVICES',
  'FINANCE',
  'INSURANCE',
  'PROPERTY',
  'UTILITIES',
  'TAX',
  'SALARIES_INCOMES',
  'INVESTMENTS',
  'FOREIGN_EXCHANGE',
  'GOVERNMENT',
  'BENEFIT_PAYMENTS',
  'MEDICAL',
  'PENSIONS'
]

export default class OpenBankingApp extends Model {
  get isDeleted () {
    return this.deletedAt != null
  }

  static get merchantCategoryCodeOptions () {
    return merchantCategoryCodes
  }

  static get ppcUserGroupOptions () {
    return OPEN_BANKING_PPC_USER_GROUPS
  }

  get schema () {
    return [
      'id',
      'name',
      'profileId',
      'profileName',
      'merchantCategoryCode',
      'ppcUserGroup',
      'yapilySubApplicationId',
      'createdAt',
      'deletedAt',
      'accountNumber',
      'restrictedIbans',
      'restrictedBankCountries',
      'restrictedSenderCountries',
      'hostedPagesCountries',
      'beneficiaryId',
      'logo'
    ]
  }
}
